class PDPKitHandler {
	constructor() {
		this.sectionId = ''
		this.products = []
		this.options = {}
		this.selectedVariants = []
	}

	// ------------------------------------------------------------ getters
	get addButtonEl() {
		return document.querySelector(`#product-template[data-id="${this.sectionId}"] .btn-kitAddToCart`)
	}

	// ------------------------------------------------------------ setters
	set setSectionId(sectionId) {
		this.sectionId = sectionId
	}

	set setProducts(products) {
		this.products = products
	}

	set setOptions(products) {
		products.forEach(product => this.options[product.kit_group ? product.kit_group : product.id] = {})
	}

	set setSelectedVariants(variants) {
		this.selectedVariants = variants
	}

	// ------------------------------------------------------------ methods
	init(products, sectionId) {
		if (products.length) {
			this.setSectionId = sectionId
			this.setProducts = products
			this.setOptions = products
			this.optionsAddEventListener()
			this.kitAddToCartAddEventListener()
		} else {
			console.error('ERROR: PDPKitHandler -> init() method: products array is empty')
		}
	}

	kitAddToCartAddEventListener() {
		if (!this.addButtonEl) return

		const self = this
		const membershipVariantId = this.addButtonEl.getAttribute('data-membership-variant-id')
		const membershipSellingPlanId = this.addButtonEl.getAttribute('data-membership-selling-plan-id')

		this.addButtonEl.addEventListener('click', e => {
			this.addButtonEl.parentElement.classList.add('is-loading')

			let kitProducts = []

			this.selectedVariants.forEach(v => {
				kitProducts.push({ id: v.id, quantity: 1 })
			})

			if (membershipVariantId && membershipSellingPlanId) {
				kitProducts.push({ id: membershipVariantId, selling_plan: membershipSellingPlanId, quantity: 1 })
			}

			bundleAddtocart(kitProducts)
		})

		document.addEventListener('addToCartLoading', function(event) {
			const loading = event.detail.loading

			if (!loading) self.addButtonEl.parentElement.classList.remove('is-loading')
		})
	}

	optionsAddEventListener() {
		document.querySelectorAll('.kit-items-wrapper .input-option')?.forEach(option => {
			option.addEventListener('change', e => {
				this.setOption(e.currentTarget)
			})
		})
	}

	setOption(currentTarget) {
		const value = currentTarget.value
		const position = currentTarget.getAttribute('data-option-position')
		const identifier =
			currentTarget.getAttribute('data-option-product-id') ||
			currentTarget.getAttribute('data-option-kit-group')

		const selectedSpan = document.querySelector(`.kit-items-wrapper span[data-selected-postion="${position}__${identifier}"]`)
		if (selectedSpan) selectedSpan.innerText = value

		this.options[identifier][`option${position}`] = value

		this.checkSoldout(identifier)
		this.checkSelectedAllOptions()
	}

	checkSoldout(identifier = '') {
		if (!identifier) return

		const isProductId = Number.isInteger(+identifier)

		const products = isProductId ? this.findProductById(identifier) : this.findProductByKitGroup(identifier)
		const initDataAtr = isProductId ? `data-option-product-id="${identifier}"` : `data-option-kit-group="${identifier}"`

		document.querySelectorAll(`.kit-items-wrapper .input-option[${initDataAtr}]`)?.forEach(option => {
			const initOptions = { ...this.options[identifier] }

			const value = option.value
			const position = option.getAttribute('data-option-position')

			initOptions[`option${position}`] = value

			const variantsFiltered = isProductId
				? this.productVariantsHandler(initOptions, products, 'filter')
				: this.productGroupVariantsHandler(initOptions, products, 'filter')

			if (variantsFiltered.length) {
				let available = true

				if (isProductId) available = variantsFiltered.some(e => e.available)
				else {
					variantsFiltered.forEach(v => {
						if (v.length && !v.some(e => e.available)) available = false
					})
				}

				if (available) {
					option.parentElement.classList.remove('soldout')
					option.parentElement.classList.add('available')
				} else {
					option.parentElement.classList.remove('available')
					option.parentElement.classList.add('soldout')
				}
			}
		})
	}

	checkSelectedAllOptions() {
		const optionsBlockEls = document.querySelectorAll(`#product-template[data-id="${this.sectionId}"] .kit-items-wrapper .options-block`)
		const inputOptionCheckedEls = document.querySelectorAll(`#product-template[data-id="${this.sectionId}"] .kit-items-wrapper .input-option:checked`)

		if ( optionsBlockEls.length === inputOptionCheckedEls.length) this.getVariants()
	}

	getVariants() {
		const variants = []

		this.products.forEach(p => {
			let initVariant = ''

			initVariant = this.productVariantsHandler(this.options[p.kit_group ? p.kit_group : p.id], p, 'find')

			if (initVariant) variants.push(initVariant)
		})

		this.setSelectedVariants = variants
		this.handleButtons(variants)
	}

	handleButtons(variants = []) {
		if (!this.addButtonEl || this.addButtonEl.getAttribute('data-is-expired')) return

		const available = variants.every(v => v.available)

		if (available) {
			this.addButtonEl.innerText = 'ADD TO CART'
			this.addButtonEl.removeAttribute('disabled')
		} else {
			this.addButtonEl.setAttribute('disabled', 'disabled')
			this.addButtonEl.innerText = 'OUT OF STOCK'
		}
	}

	findProductById(productId) {
		return this.products.find(product => product.id === Number(productId))
	}

	findProductByKitGroup(kitGroup) {
		return this.products.filter(product => product.kit_group === kitGroup)
	}

	productVariantsHandler(initOptions, product = {}, method) {
		const variants = product.variants

		if (!initOptions || !variants) return false

		return variants[method](variant => {
			// checking for out of stock when if first option is not selected
			const optionsKeys = Object.keys(initOptions)
			const productOptionsLength = product.options?.length || Number(product.option_size) || 0

			if ((optionsKeys.length === 1 || productOptionsLength === 1) && !product.kit_group) {
				const optionKey = optionsKeys[0]
				return variant[optionKey] === initOptions[optionKey]
			}

			return this.compareOptions(initOptions, variant)
		})
	}

	productGroupVariantsHandler(initOptions, products = [], method) {
		let fullVar = []

		products.forEach(product => {
			fullVar.push(product.variants[method](variant => this.compareOptions(initOptions, variant)))
		})

		return fullVar
	}

	compareOptions(initOptions, variant) {
		const initVariantOptions = variant.options

		initVariantOptions.forEach((v, index) => initVariantOptions[index] = this.handleVariant(v))

		const existOptions = []

		if (initVariantOptions.includes(initOptions['option1'])) existOptions.push(true)
		if (initVariantOptions.includes(initOptions['option2'])) existOptions.push(true)
		if (initVariantOptions.includes(initOptions['option3'])) existOptions.push(true)

		return existOptions.length ===initVariantOptions.length
	}

	handleVariant(variant) {
		return variant?.replace('\"', '')
	}
}

const FctApp = window.FctApp
FctApp.PDPKitHandler = PDPKitHandler
